import * as angular from 'angular';
import { LineCounts } from "../../models/counts/lineCounts";
import { apsDisplayEnums } from "../../shared/dto/enums";
import { UIUtilityService } from "../../services/utility/uiUtility.service";
import { IBtn, IBtnArrayOptions } from './btnarray.interfaces';
import * as _ from "lodash";

interface RejectGraphData extends angular.IScope {
  model: LineCounts;
  interval: apsDisplayEnums.CountDisplayInterval;
  equipmentSelected: (dimpleEvent: any) => void;
}

export default angular
  .module('aps.controller.topRejectsGraph', [])
  .controller('TopRejectsGraphCtrl', topRejectsGraphCtrl)
  .name;

function topRejectsGraphCtrl(
  $scope: RejectGraphData,
  uiUtilityService: UIUtilityService) {

  let vm = {
    showIfEmpty: true,
    equipmentSelected: $scope.equipmentSelected,
    model: $scope.model,
    renderChart: null,
    rejectNameToColor: {},
    shiftSelectors: {
      buttons: [],
      select: null
    } as IBtnArrayOptions,
    setShift: null,
    selectShift: null,
    interval: $scope.interval,
    rejectsPretty: {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      yAxis: {
        title: { enabled: false }
      },
      xAxis: {
        categories: []
      },
      legend: { enabled: false },
      credits: {
        enabled: false
      },
      exporting: { enabled: false },
      tooltip: {
        formatter: function () {
          return 'Defect: <b>' + this.x + '</b><br />'
            + this.series.name + ': <b>' + this.y + '</b>';
        }
      },
      series: [],
      reflow: true,
      callBack: null // angular.bind(this, this.chartClickWorkaround.defectBarClick)
    }
  };

  let intervals = apsDisplayEnums.CountDisplayInterval;
  let interval = apsDisplayEnums.CountDisplayInterval.Last24Hours;
  while (intervals[interval]) {
    vm.shiftSelectors.buttons.push({
      name: intervals[interval], // Last 24 Hours
      value: interval,
      selected: vm.shiftSelectors.buttons.length === 0
    });
    interval++;
  }

  vm.renderChart = () => {
    var data = vm.model.equipmentGroups
      .filter(e => e.hasRejects);

    vm.rejectsPretty.xAxis.categories = data.map(e => e.name);

    for (let i = 0; i < data.length; i++) {
      let color = uiUtilityService.getRejectColor(i);
      if (color) {
        vm.rejectNameToColor[vm.rejectsPretty.xAxis.categories[i]] = color;
      }
    }

    vm.rejectsPretty.xAxis.categories = data.map(e => e.name);
    vm.rejectsPretty.series = [{
      name: 'Count',
      data: data.map(d => {
        return {
          y: d.rejectCount.count,
          color: vm.rejectNameToColor[d.name],
          events: {
            click: function (event: any) {
              vm.equipmentSelected({
                category: this.category,
                y: this.y
              });
            }
          }
        };
      })
    }];
  };

  vm.setShift = (shiftValue: apsDisplayEnums.CountDisplayInterval) => {
    vm.shiftSelectors.buttons.forEach(s => {
      s.selected = (s.value === shiftValue);
    });
  };

  vm.selectShift = (shift: IBtn) => {
    // update buttons
    // vm.shiftSelectors.buttons.forEach(s => s.selected = false);
    // shift.selected = true;

    // change model interval and redraw chart
    vm.interval = shift.value;
    vm.model.handleIntervalChange(shift.value);
    vm.renderChart();
  };

  vm.shiftSelectors.select = (button: IBtn) => {
    vm.selectShift(button);
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/topRejectsGraph.controller.ts